window.VH = window.VH === undefined ? {} : window.VH;
VH.AjaxModal = {
  init: function init() {
    let modal = $('#ajaxModal');
    $('#wrapper').on('click', '.ajaxModal', function () {
      let $this = $(this);
      let url = $this.attr('href');
      let size = $this.data('ajax-modal-size');
      $('.modal-header h4', modal).html($this.data('ajax-modal-title'));
      if (size) {
        $('.modal-dialog', modal).addClass(size);
      }

      if (url === '#') {
        modal.modal('show');
      }
      else {
        $.get(url, function (data) {
          $('.modal-body', modal).html(data);
          modal.modal('show');
        });
      }
      return false;
    });
  },
};
